// Firebase Analytics (GA4). 익명·집계 전용. ★쓴 글 원문·헤드라인 등 콘텐츠는 절대 안 보낸다.
// 보내는 건 score·archetype·lang·길이버킷·게이트·광고 포맷 같은 행동/메타 지표뿐(프라이버시 약속 유지).
// VITE_FIREBASE_* 미설정이면 전부 no-op(dev/프리뷰 안전). 웹 + Capacitor 웹뷰에서 동작.
// firebase는 동적 import로 코드 스플릿 — 미설정이면 아예 로드 안 함, 메인 번들 가볍게.
// 네이티브 디바이스 단위 정확도가 필요하면 @capacitor-firebase/analytics로 교체(이 파일만 바꾸면 됨).

import type { Analytics } from "firebase/analytics";

const env = (typeof import.meta !== "undefined" && import.meta.env) || ({} as Record<string, string>);

const config = {
  apiKey: env.VITE_FIREBASE_API_KEY,
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.VITE_FIREBASE_SENDER_ID,
  appId: env.VITE_FIREBASE_APP_ID,
  measurementId: env.VITE_FIREBASE_MEASUREMENT_ID,
};
const configured = Boolean(config.apiKey && config.measurementId);

type Params = Record<string, string | number | boolean>;
type LogEvent = (a: Analytics, name: string, params?: Params) => void;

let analytics: Analytics | null = null;
let logEventFn: LogEvent | null = null;
let started = false;

/** 앱 시작 시 1회. 설정·지원 시에만 firebase를 동적 로드해 초기화. 미설정/미지원이면 no-op. */
export async function initAnalytics(): Promise<void> {
  if (started || !configured) return;
  started = true;
  try {
    const [{ initializeApp }, fa] = await Promise.all([
      import("firebase/app"),
      import("firebase/analytics"),
    ]);
    if (!(await fa.isSupported())) return; // 일부 웹뷰/SSR 미지원
    analytics = fa.getAnalytics(initializeApp(config));
    logEventFn = fa.logEvent as LogEvent;
  } catch {
    /* 초기화 실패해도 앱은 동작 */
  }
}

/** 이벤트 기록. 반드시 콘텐츠 제외(행동/메타만). 미초기화면 no-op. */
export function track(name: string, params?: Params): void {
  if (!analytics || !logEventFn) return;
  try {
    logEventFn(analytics, name, params);
  } catch {
    /* 무시 */
  }
}

/** 글 길이를 버킷으로(정확 길이 대신, 콘텐츠 추정 여지 최소화). */
export function lengthBucket(chars: number): string {
  if (chars < 14) return "xs";
  if (chars < 60) return "s";
  if (chars < 140) return "m";
  if (chars < 280) return "l";
  return "xl";
}
